import { BUSCAR_EMPRESAS } from '../../actions/types'

const initialState = undefined

export default function reducerEmpresas (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_EMPRESAS: {
      const empresas = action.payload.data.sort((n1, n2) => {
        if (n1.nome > n2.nome) {
          return 1;
        }

        if (n1.nome < n2.nome) {
          return -1;
        }

        return 0;
      });

      if (empresas) {
        return empresas
      }
      return []
    }

    default: {
      return state
    }
  }
}
